<template>
    <v-app-bar app flat light>
        <v-app-bar-nav-icon @click="$emit('toggle')" />
        <v-toolbar-title>{{ title }}</v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="pa-2"><v-btn block link @click="logout">Logout</v-btn></div>
    </v-app-bar>
</template>

<script>
export default {
    props: [ 'title' ],

    data() {
        return {
            isLoading: false
        }
    },

    methods: {

       logout() {
         this.isLoading = true
         this.$store.dispatch('userSignOut')
       },

    }
}
</script>
